export default "/images/vendor/flag-icons/flags/4x3/pr.svg?52e728e052169b21894df74ac65d5729";